export default "__VITE_ASSET__C_I_TJpl__"